<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { SHARED } from "@/constants";
import { customerService } from "@/helpers/services/customer.service";
import { sharedHelper, filtersHelper } from "@/utils";

// Admin view of registered customers (patients): VIEW only + lock/unlock login.
export default {
  page: { title: "Customers" },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Customers",
      breadcrumbItems: [{ text: "Customers", active: true }],
      filter: "",
      currentPage: 1,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      rows: [],
      pagination: { total: 0 },
      searchCriteria: {
        pageNumber: 1,
        pageSize: SHARED.DEFAULT_PAGE_SIZE,
        search: "",
      },
      fields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "isVerified", label: "Verified" },
        { key: "isActive", label: "Status" },
        { key: "isAllowLogin", label: "Allow Login" },
        { key: "createdAt", label: "Registered" },
      ],
    };
  },
  computed: {
    tableRows() {
      return this.rows;
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      try {
        const r = await customerService.getCustomers(this.searchCriteria);
        this.rows = (r?.data || []).map((c) => ({
          uuid: c.uuid,
          name: c.name,
          email: c.email,
          phone: c.phone || "-",
          isVerified: c.is_verified,
          isActive: c.is_active,
          isAllowLogin: c.is_allow_login,
          createdAt: c.created_at
            ? filtersHelper.getDateFormat(c.created_at)
            : "",
        }));
        this.pagination = r?.pagination || { total: 0 };
      } catch (e) {
        sharedHelper.alertErrorMessage(
          sharedHelper.getErrorMessage(e),
          e?.response?.data?.code
        );
      }
    },
    searchListing() {
      this.searchCriteria.pageNumber = 1;
      this.searchCriteria.search = this.filter;
      this.currentPage = 1;
      this.fetch();
    },
    pageNavigation(p) {
      this.searchCriteria.pageNumber = p;
      this.fetch();
    },
    async toggleLoginAccess(row) {
      try {
        await customerService.updateCustomerLoginAccess(
          row.uuid,
          !row.isAllowLogin
        );
        sharedHelper.alertSuccessMessage(
          row.isAllowLogin ? "Customer locked" : "Customer unlocked"
        );
        this.fetch();
      } catch (e) {
        sharedHelper.alertErrorMessage(
          sharedHelper.getErrorMessage(e),
          e?.response?.data?.code
        );
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbItems" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2 mb-3">
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center">
                  {{ $t('label.search') }}
                  <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                    class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage">
                <template #cell(isVerified)="data">
                  <b-badge variant="success" v-if="data.item.isVerified">{{ $t('label.yes') }}</b-badge>
                  <b-badge variant="warning" v-else>{{ $t('label.no') }}</b-badge>
                </template>
                <template #cell(isActive)="data">
                  <b-badge variant="success" v-if="data.item.isActive">{{ $t('label.active') }}</b-badge>
                  <b-badge variant="secondary" v-else>{{ $t('label.inactive') }}</b-badge>
                </template>
                <template #cell(isAllowLogin)="data">
                  <b-form-checkbox
                    switch
                    :disabled="!$can('Update Customer')"
                    :checked="data.item.isAllowLogin"
                    @change="toggleLoginAccess(data.item)"
                  >
                    <span :class="data.item.isAllowLogin ? 'text-success' : 'text-danger'">
                      {{ data.item.isAllowLogin ? $t('label.yes') : $t('label.no') }}
                    </span>
                  </b-form-checkbox>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="perPage" @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
